import {useEffect, useState} from 'react';
import * as qs from "query-string";
import {useHistory} from 'react-router-dom';
import Util from '../../utils/utils';
import {OauthAPIInstance} from '../../api/app-api';
import {DEFAULT_MESSAGE} from '../../api/error-code';
import { isMobile } from 'react-device-detect';

const BINDING_CREATED = 'CREATED';
const BINDING_ACTIVE = 'ACTIVE';
const BINDING_EXPIRED = 'EXPIRED';
const RETURN_CODE_EXPIRED = -7025;
const BINDING_LEGACY_MAP = {
    0: "CREATED",
    1: "ACTIVE",
    2: "REVOKED",
    3: "REVOKED",
    4: "REVOKED",
    5: "EXPIRED",
    6: "PENDING",
}

export function useBindingInfoAPI () {
    const [bindingInfo, setBindingInfo] = useState({})
    const history = useHistory();

    const getNewBinding = async (bindingID) => {
        const resp = await OauthAPIInstance.getBinding(bindingID);
        if (resp.status === 200) {
            return await resp.json();
        }
        console.log("error", "getBindingInfo error= ", resp.status, resp);
        Util.hideLoading()
        history.replace('/result', {
            step: -1,
            return_code: -7001,
            return_message: DEFAULT_MESSAGE,
            binding_info: bindingInfo
        });
    }

    const getBinding = async (bindingID) => {
        const binding = await getNewBinding(bindingID);
        checkBindingStatus(binding?.status);
        Util.hideLoading();
        return  {
            binding_token: binding.id,
            app_id : binding.merchant.app_id,
            app_icon_url : binding.merchant.logo,
            merchant_name : Util.getCustomMerchantName(binding),
            redirect_url : binding.merchant.link.redirect_url,
            identifier : binding.merchant?.user_id,
            status : binding.status,
            is_legacy: false,
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect( () => {
        const fetchBinding = async () => {
            Util.showLoading();
            let params = qs.parse(window.location.href.split('?')[1]);
            if (Object.entries(params).length !== 0 && params.constructor !== Object) {
                let binding_token = params.binding_token ?? params.requestid;
                let bindingInfo =  await getBinding(binding_token);
                setBindingInfo(bindingInfo);
            } else {
                throw "error: params is null"
            }
            Util.hideLoading();
        }
        fetchBinding().catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkBindingStatus = (status) => {
        let resultPage = '/result'
        if (isMobile) {
            resultPage = '/binding/result'
        }

        switch (status) {
            case BINDING_CREATED:
                return;
            case BINDING_ACTIVE:
                history.replace(resultPage, {
                    step: 1,
                    status:1,
                    return_code: 1,
                    binding_info: bindingInfo
                });
                return;
            case BINDING_EXPIRED:
                history.replace(resultPage, {
                    step: -1,
                    status: status,
                    return_code: RETURN_CODE_EXPIRED,
                    binding_info: bindingInfo
                });
                return;
            default:
                history.replace(resultPage, {
                    step: -1,
                    status: status,
                    return_code: -7001,
                    return_message: DEFAULT_MESSAGE,
                    binding_info: bindingInfo
                });
                return;
        }
    }
    
    return bindingInfo;
}
